// extracted by mini-css-extract-plugin
export default {"galleryHeading":"photo_galleryHeading__ch5Rw","image":"photo_image__+6vRN","galleryContainer":"photo_galleryContainer__qOyKF"};